import React from 'react';

import styles from './work.module.css';
import Icon from './Icon';

import gif from './../images/apigif.gif';

const WorkCard = ({name, ghLink, liveLink, image, description, tags, onClick}) => {

  const select = () => {
    onClick({name, liveLink, ghLink, image, description, tags})
  }

  return (
    <div className={styles.cardWrapper} onClick={select}>
      <div className={styles.title}>
        {name}
      </div>
      <div className={styles.image}>
        <img className={styles.workImage} src={image} alt="gif" />
      </div>
      <div className={styles.description}>
        {description}
      </div>
      <div className={styles.tags}>
        {
          tags.map(tag => <div className={styles.tag}> <Icon type={tag} /> </div>)
        }
      </div>
    </div>
  )
}

export default WorkCard;